/* eslint-disable */
// source: dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.dashboard.private.dashboard.DashboardHeader', null, global);
goog.exportSymbol('proto.dashboard.private.dashboard.GetDashboardRequest', null, global);
goog.exportSymbol('proto.dashboard.private.dashboard.GetDashboardResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.private.dashboard.GetDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.private.dashboard.GetDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.private.dashboard.GetDashboardRequest.displayName = 'proto.dashboard.private.dashboard.GetDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.private.dashboard.GetDashboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.private.dashboard.GetDashboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.private.dashboard.GetDashboardResponse.displayName = 'proto.dashboard.private.dashboard.GetDashboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.dashboard.private.dashboard.DashboardHeader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.dashboard.private.dashboard.DashboardHeader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.dashboard.private.dashboard.DashboardHeader.displayName = 'proto.dashboard.private.dashboard.DashboardHeader';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.private.dashboard.GetDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.private.dashboard.GetDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.private.dashboard.GetDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.GetDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.private.dashboard.GetDashboardRequest}
 */
proto.dashboard.private.dashboard.GetDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.private.dashboard.GetDashboardRequest;
  return proto.dashboard.private.dashboard.GetDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.private.dashboard.GetDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.private.dashboard.GetDashboardRequest}
 */
proto.dashboard.private.dashboard.GetDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.private.dashboard.GetDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.private.dashboard.GetDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.private.dashboard.GetDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.GetDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.dashboard.private.dashboard.GetDashboardRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.private.dashboard.GetDashboardRequest} returns this
 */
proto.dashboard.private.dashboard.GetDashboardRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.private.dashboard.GetDashboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.private.dashboard.GetDashboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.GetDashboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    header: (f = msg.getHeader()) && proto.dashboard.private.dashboard.DashboardHeader.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.private.dashboard.GetDashboardResponse}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.private.dashboard.GetDashboardResponse;
  return proto.dashboard.private.dashboard.GetDashboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.private.dashboard.GetDashboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.private.dashboard.GetDashboardResponse}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.dashboard.private.dashboard.DashboardHeader;
      reader.readMessage(value,proto.dashboard.private.dashboard.DashboardHeader.deserializeBinaryFromReader);
      msg.setHeader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.private.dashboard.GetDashboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.private.dashboard.GetDashboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.GetDashboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeader();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.dashboard.private.dashboard.DashboardHeader.serializeBinaryToWriter
    );
  }
};


/**
 * optional DashboardHeader header = 1;
 * @return {?proto.dashboard.private.dashboard.DashboardHeader}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.getHeader = function() {
  return /** @type{?proto.dashboard.private.dashboard.DashboardHeader} */ (
    jspb.Message.getWrapperField(this, proto.dashboard.private.dashboard.DashboardHeader, 1));
};


/**
 * @param {?proto.dashboard.private.dashboard.DashboardHeader|undefined} value
 * @return {!proto.dashboard.private.dashboard.GetDashboardResponse} returns this
*/
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.setHeader = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.dashboard.private.dashboard.GetDashboardResponse} returns this
 */
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.clearHeader = function() {
  return this.setHeader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.dashboard.private.dashboard.GetDashboardResponse.prototype.hasHeader = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.toObject = function(opt_includeInstance) {
  return proto.dashboard.private.dashboard.DashboardHeader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dashboard.private.dashboard.DashboardHeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.DashboardHeader.toObject = function(includeInstance, msg) {
  var f, obj = {
    mrrFormatted: jspb.Message.getFieldWithDefault(msg, 1, ""),
    netSalesMtdFormatted: jspb.Message.getFieldWithDefault(msg, 2, ""),
    netRevenueMtdFormatted: jspb.Message.getFieldWithDefault(msg, 3, ""),
    activeSubscriptionsCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    unpaidInvoicesCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    unpaidInvoicesFormatted: jspb.Message.getFieldWithDefault(msg, 6, ""),
    expiredCardsCount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dashboard.private.dashboard.DashboardHeader}
 */
proto.dashboard.private.dashboard.DashboardHeader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.dashboard.private.dashboard.DashboardHeader;
  return proto.dashboard.private.dashboard.DashboardHeader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dashboard.private.dashboard.DashboardHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dashboard.private.dashboard.DashboardHeader}
 */
proto.dashboard.private.dashboard.DashboardHeader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMrrFormatted(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetSalesMtdFormatted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetRevenueMtdFormatted(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActiveSubscriptionsCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnpaidInvoicesCount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnpaidInvoicesFormatted(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpiredCardsCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.dashboard.private.dashboard.DashboardHeader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dashboard.private.dashboard.DashboardHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.dashboard.private.dashboard.DashboardHeader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMrrFormatted();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetSalesMtdFormatted();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNetRevenueMtdFormatted();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActiveSubscriptionsCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getUnpaidInvoicesCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getUnpaidInvoicesFormatted();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExpiredCardsCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional string mrr_formatted = 1;
 * @return {string}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getMrrFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setMrrFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string net_sales_mtd_formatted = 2;
 * @return {string}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getNetSalesMtdFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setNetSalesMtdFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string net_revenue_mtd_formatted = 3;
 * @return {string}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getNetRevenueMtdFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setNetRevenueMtdFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 active_subscriptions_count = 4;
 * @return {number}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getActiveSubscriptionsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setActiveSubscriptionsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 unpaid_invoices_count = 5;
 * @return {number}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getUnpaidInvoicesCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setUnpaidInvoicesCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string unpaid_invoices_formatted = 6;
 * @return {string}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getUnpaidInvoicesFormatted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setUnpaidInvoicesFormatted = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 expired_cards_count = 7;
 * @return {number}
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.getExpiredCardsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.dashboard.private.dashboard.DashboardHeader} returns this
 */
proto.dashboard.private.dashboard.DashboardHeader.prototype.setExpiredCardsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


goog.object.extend(exports, proto.dashboard.private.dashboard);
